'use client'
import {
  useConfig_default
} from "./chunk-UDUUTZIS.mjs";

// src/hooks/useSubscriptionConfig.ts
var useSubscriptionConfig = () => {
  var _a;
  const { subscriptions } = useConfig_default();
  return {
    active: (_a = subscriptions == null ? void 0 : subscriptions.active) != null ? _a : true
  };
};

export {
  useSubscriptionConfig
};
//# sourceMappingURL=chunk-DKH2AGD3.mjs.map